<div *ngIf="!afterSignupLogic && pageLoaded" class="auth-container" [ngClass]="{ mobile: isMobile$ | async }">
  <mat-card>
    <h1 class="mat-headline-3">
      {{ 'WM_TECH.AUTH.' + (invitedEmail ? 'INVITE.' : '') + 'SIGNUP.TITLE' | translate }}
    </h1>
    <h2 class="mat-subtitle-2">
      {{ 'WM_TECH.AUTH.' + (invitedEmail ? 'INVITE.' : '') + 'SIGNUP.SUBTITLE' | translate }}
    </h2>

    <mat-card-content>
      <form [formGroup]="signupForm" (ngSubmit)="signUp()">
        <h2 class="mat-body-2 italic">
          {{ 'WM_TECH.AUTH.CHOOSE_COUNTRY' | translate }}
        </h2>

        <mat-form-field appearance="outline" class="wm-select mb-1">
          <mat-select [placeholder]="'WM_TECH.AUTH.SIGNUP.COUNTRY' | translate" formControlName="country" required panelClass="wm-select-panelClass" [value]="defaultCountryByLocation || 'Am'">
            @for (countryCode of countries | keyvalue; track countryCode) {
            <mat-option [value]="countryCode.key">
              {{ countryCode.key | countryName }}
            </mat-option>
            }
          </mat-select>
          <mat-error>{{ 'WM_TECH.AUTH.SIGNUP.VALIDAION.COUNTRY.ERROR' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="wm-input">
          <input formControlName="personalName" matInput [placeholder]="'WM_TECH.SIGNUP.YOUR_NAME' | translate" type="text" required />
          <mat-error>{{ 'WM_TECH.AUTH.SIGNUP.VALIDAION.NAME.ERROR' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="wm-input">
          <input formControlName="personalSurname" [placeholder]="'WM_TECH.SIGNUP.YOUR_SURNAME' | translate" matInput type="text" required />
          <mat-error>{{ 'WM_TECH.AUTH.SIGNUP.VALIDAION.SURNAME.ERROR' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="wm-input">
          <input matInput type="email" formControlName="email" [placeholder]="'WM_TECH.FORMS.EMAIL' | translate" />
          <mat-error>{{ 'WM_TECH.AUTH.SIGNUP.VALIDAION.EMAIL.ERROR' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="wm-input">
          <input formControlName="password" matInput [placeholder]="'WM_TECH.SIGNUP.PASSWORD' | translate" [type]="hidePassword ? 'password' : 'text'" required />
          <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error>{{ 'WM_TECH.AUTH.SIGNUP.VALIDAION.PASSWORD.ERROR' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="wm-input">
          <input formControlName="confirmPassword" [placeholder]="'WM_TECH.SIGNUP.CONFIRM_PASSWORD' | translate" matInput [type]="hideConfirmPassword ? 'password' : 'text'" required />
          <button mat-icon-button matSuffix type="button" (click)="hideConfirmPassword = !hideConfirmPassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfirmPassword">
            <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error>{{ 'WM_TECH.AUTH.SIGNUP.VALIDAION.CONFIRM_PASSWORD.ERROR' | translate }}</mat-error>
        </mat-form-field>

        <mat-checkbox formControlName="agreeToTerms" ngDefaultControl color="accent">
          {{ 'WM_TECH.AUTH.SIGNUP.AGREE_1' | translate }}
          <a routerLink="/terms" target="_blank">{{ 'WM_TECH.AUTH.SIGNUP.TERMS' | translate }}</a>
          {{ 'WM_TECH.AUTH.SIGNUP.AGREE_2' | translate }}
          <a routerLink="/privacy" target="_blank">{{ 'WM_TECH.AUTH.SIGNUP.PRIVACY' | translate }}.</a>
        </mat-checkbox>

        <button mat-raised-button color="tech-button-bg-primary" type="submit" class="submit-button" [disabled]="signupForm.invalid">
          {{ 'WM_TECH.SIGNUP.SIGNUP' | translate }}
        </button>
      </form>

      <div class="auth-links">
        <p>
          {{ 'WM_TECH.AUTH.SIGNUP.HAVE_ACCOUNT' | translate }}
          <a routerLink="/auth/sign-in">{{ 'WM_TECH.AUTH.SIGNUP.SIGNIN' | translate }}.</a>
        </p>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<app-after-signup *ngIf="afterSignupLogic" [userEmail]="userEmail"></app-after-signup>
